var map = {
	"./en.json": 1005,
	"./jp.json": 9494,
	"./ko.json": 3355,
	"./zhCN.json": 7617,
	"./zhTW.json": 326
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6192;
module.exports = webpackAsyncContext;